import DirectMessagesAPI from '@/modules/directmessages/api/directmessages'

export default {
  updateDirectMessages({ commit }) {
    return DirectMessagesAPI.getDirectMessages().then((data) => {
      commit('setDirectMessages', data.directMessages)
    })
  },
}
